export default __webpack_public_path__ + "static/media/lock.bf4d9cab.svg";